import { useRef } from "react";
import { OptisignsPickerSdk } from "@optisigns/picker-sdk";
import { auth } from "@/lib/firebase";

interface UseOptiSignsPickerOptions {
  projectId?: string;
  workspaceId?: string;
  publishedUrl?: string;
  slug?: string;
  name?: string;
}

export function useOptiSignsPicker(options: UseOptiSignsPickerOptions = {}) {
  const sdkRef = useRef<OptisignsPickerSdk | null>(null);

  const openPicker = async () => {
    // Get fresh token - uses embed-aware auth (Firebase or postMessage bridge)
    const freshToken = await auth.getIdToken();
    if (!freshToken) {
      console.error("No authenticated user");
      return;
    }

    // Re-initialize SDK with fresh token
    sdkRef.current?.dispose();
    sdkRef.current = new OptisignsPickerSdk({
      graphqlEndpoint: import.meta.env.VITE_OPTISIGNS_GRAPHQL_ENDPOINT || "https://qa3b-api.opstech.org/graphql",
      pickerUrl: import.meta.env.VITE_OPTISIGNS_PICKER_URL || "https://optisigns-picker-sdk.pages.dev",
      accessToken: freshToken,
      payload: {
        appType: "optidev",
        originalFileName: options.slug,
        projectName: options.name,
        projectId: options.projectId,
        workspaceId: options.workspaceId,
        url: options.publishedUrl,
      },
      mediaType: "asset",
      modalMode: "wide",
      branding: {
        primaryColor: '#5C41E6',
        secondaryColor: '#5C41E6',
        iconType: 'optidev'
      }
    });

    const result = await sdkRef.current?.openModalAsync();
    return result;
  };

  return { openPicker };
}
